import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const data = [{
  name: 'Sem 1',
  visits: 4
}, {
  name: 'Sem 2',
  visits: 3
}, {
  name: 'Sem 3',
  visits: 5
}, {
  name: 'Sem 4',
  visits: 2
}, {
  name: 'Sem 5',
  visits: 1
}, {
  name: 'Sem 6',
  visits: 0
}];
export function AttendanceChart() {
  return <div className="h-64 w-full" data-id="element-33">
      <ResponsiveContainer width="100%" height="100%" data-id="element-34">
        <AreaChart data={data} margin={{
        top: 10,
        right: 10,
        left: 0,
        bottom: 0
      }} data-id="element-35">
          <defs data-id="element-36">
            <linearGradient id="colorVisits" x1="0" y1="0" x2="0" y2="1" data-id="element-37">
              <stop offset="5%" stopColor="#FF6B35" stopOpacity={0.8} data-id="element-38" />
              <stop offset="95%" stopColor="#FF6B35" stopOpacity={0} data-id="element-39" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-40" />
          <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
          fill: '#718096',
          fontSize: 12
        }} dy={10} data-id="element-41" />
          <YAxis axisLine={false} tickLine={false} tick={{
          fill: '#718096',
          fontSize: 12
        }} data-id="element-42" />
          <Tooltip contentStyle={{
          borderRadius: '8px',
          border: 'none',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
        }} data-id="element-43" />
          <Area type="monotone" dataKey="visits" stroke="#FF6B35" strokeWidth={3} fillOpacity={1} fill="url(#colorVisits)" data-id="element-44" />
        </AreaChart>
      </ResponsiveContainer>
    </div>;
}